import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { navLinks } from '@/mocks/navigation';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const isActive = (href: string) => {
    if (href === '/') return location.pathname === '/';
    return location.pathname.startsWith(href);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
              <i className="ri-gamepad-line text-lg text-background-50"></i>
            </div>
            <span className="text-xl font-bold font-heading text-foreground-900">
              九游娱乐
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                  isActive(link.href)
                    ? 'text-primary-600 bg-primary-100/70'
                    : 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/articles"
              className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-foreground-900 transition-colors duration-200 whitespace-nowrap"
            >
              登录
            </Link>
            <Link
              to="/categories"
              className="px-5 py-2 text-sm font-semibold bg-primary-500 text-background-50 rounded-lg hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
            >
              立即注册
            </Link>
          </div>

          <button
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg hover:bg-background-100 transition-colors"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl text-foreground-800 ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-2">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors duration-200 ${
                  isActive(link.href)
                    ? 'text-primary-600 bg-primary-100/70'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="flex gap-3 pt-2 border-t border-background-200/70 mt-1">
              <Link
                to="/articles"
                className="flex-1 px-4 py-2.5 text-center text-sm font-medium text-foreground-700 border border-background-300/60 rounded-lg hover:bg-background-100 transition-colors whitespace-nowrap"
              >
                登录
              </Link>
              <Link
                to="/categories"
                className="flex-1 px-4 py-2.5 text-center text-sm font-semibold bg-primary-500 text-background-50 rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                立即注册
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}